import * as React from "react";
import Component from "../../AbstractComponent";
import PersonSummary from "./PersonSummary";
import PersonDetailsEditable from "./PersonDetailsEditable";
import PersonDetailsReadonly from "./PersonDetailsReadonly";

import {
	Card
} from '@material-ui/core';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

export default class PersonCard extends Component {
	public state = {
		isSummaryView: true
	};

  constructor(public props) {
    super(props);

		let isSummaryView = true;

		if (this.props.dialogPresentation) {
			isSummaryView = false;
		}

		if (typeof this.props.isSummaryView !== "undefined") {
			isSummaryView = this.props.isSummaryView;
		}

		const isReadonly = this.props.person?.isReadonly ||
											 this.props.isReadonly;

		if ((this.props.mainCardPresentation && isReadonly) || this.props.openedByDefault) {
			isSummaryView = false;
		}

		this.state.isSummaryView = isSummaryView;
	}

	public changeView = (): void => {
		if (typeof this.props.personIdForDetailsPresentation !== "undefined") {
			if (this.props.personIdForDetailsPresentation === this.props.person?.id) {
				this.props.changePersonIdForDetailsPresentation.call(this, null);
			} else {
				this.props.changePersonIdForDetailsPresentation.call(this, this.props.person?.id);
			} 
		} else {
			this.setState({
				isSummaryView: !this.state.isSummaryView
			})
		}
	}
	
  public render() {
		const isReadonly = this.props.person?.isReadonly ||
											 this.props.isReadonly;

		const isSummaryView = typeof this.props.personIdForDetailsPresentation !== "undefined" ?
														this.props.personIdForDetailsPresentation !== this.props.person?.id :
														this.state.isSummaryView;

    return (
			<Card 
				className="card no-padding" 
				style={{position: "relative"}}
				onClick={isSummaryView ? this.changeView : null}
			>
				<div 
					className="right-buttons" 
					style={{
						position: "absolute",
						right: 0,
						width: "40px",
						display: "flex",
						flexDirection: "column",
						alignItems: "center"
					}} 
					onClick={!isSummaryView ? this.changeView : null}
				>
					{
						isSummaryView ? 
							<ExpandMore style={{cursor: "pointer"}} onClick={this.changeView}/> : 
							<ExpandLess style={{cursor: "pointer"}} onClick={this.changeView}/>
					}
				</div>

				<div className="main-inner-wrapper" style={{padding: "10px 40px 10px 10px", marginBottom: "10px"}}>
				{
						isSummaryView && <PersonSummary {...this.props}/>
					}

					{
						!isSummaryView && (isReadonly || !this.props.mainCardPresentation) && <PersonDetailsReadonly {...this.props} />
					}

					{
						!isSummaryView && !isReadonly && this.props.mainCardPresentation && <PersonDetailsEditable {...this.props} />
					}
				</div>
				<div style={{height: "1px"}}></div>
			</Card>
    );
  }
}
